import { Mail, Phone, MapPin } from 'lucide-react';
import { SiApplepay, SiGooglepay, SiVenmo, SiPaypal, SiCashapp } from 'react-icons/si';
import { FaMoneyBillWave } from 'react-icons/fa';

export function Footer() {
  return (
    <footer className="bg-[#12233a] text-[#f2eee8] py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Business Info */}
          <div className="md:col-span-2">
            <h3
              className="text-2xl mb-2 text-[#c8a96a] text-left"
              style={{ fontFamily: 'Cinzel, serif', fontWeight: 700 }}
            >
              Wiggy's Wags and Wiggles 🐾
            </h3>
            <p
              className="text-[#f2eee8] text-left m-0 mb-3"
              style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}
            >
              Where Every Tail Tells a Story
            </p>
            <p
              className="text-[#f2eee8]/80 text-left text-sm max-w-md"
              style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400 }}
            >
              Your pup's happy place in Suffolk, VA! Proudly serving the Hampton Roads Seven Cities with love, care, and plenty of tail wags.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4
              className="mb-4 text-[#c8a96a]"
              style={{ fontFamily: 'Cinzel, serif', fontWeight: 600 }}
            >
              Contact Us
            </h4>
            <div className="space-y-3">
              <a
                href="tel:8723576339"
                className="flex items-center gap-2 hover:text-[#c8a96a] transition-colors cursor-pointer"
              >
                <Phone size={18} className="text-[#c8a96a]" />
                <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400 }}>
                  (872) 357-6339
                </span>
              </a>
              <a
                href="mailto:jasonewigman2@gmail.com"
                className="flex items-center gap-2 hover:text-[#c8a96a] transition-colors cursor-pointer"
              >
                <Mail size={18} className="text-[#c8a96a]" />
                <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400 }}>
                  jasonewigman2@gmail.com
                </span>
              </a>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=4552+Shoulder+Hills+Rd,+Suffolk,+VA+23435"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#c8a96a] transition-colors cursor-pointer"
              >
                <MapPin size={18} className="text-[#c8a96a]" />
                <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400 }}>
                  4552 Shoulder Hills Rd, Suffolk, VA 23435
                </span>
              </a>
            </div>
          </div>
        </div>

        {/* Payment Options */}
        <div className="border-t border-[#c8a96a]/30 mt-8 pt-8">
          <div className="text-center mb-6">
            <h4
              className="text-lg mb-4 text-[#c8a96a]"
              style={{ fontFamily: 'Cinzel, serif', fontWeight: 600 }}
            >
              Accepted Payment Methods
            </h4>
            <div className="flex flex-wrap justify-center items-center gap-6">
              <a
                href="https://www.apple.com/apple-pay/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#f2eee8] hover:text-[#c8a96a] transition-colors"
                style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}
              >
                <SiApplepay className="text-2xl" />
                <span>Apple Pay</span>
              </a>
              <a
                href="https://pay.google.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#f2eee8] hover:text-[#c8a96a] transition-colors"
                style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}
              >
                <SiGooglepay className="text-2xl" />
                <span>Google Pay</span>
              </a>
              <a
                href="https://venmo.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#f2eee8] hover:text-[#c8a96a] transition-colors"
                style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}
              >
                <SiVenmo className="text-2xl" />
                <span>Venmo</span>
              </a>
              <a
                href="https://cash.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#f2eee8] hover:text-[#c8a96a] transition-colors"
                style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}
              >
                <SiCashapp className="text-2xl" />
                <span>Cash App</span>
              </a>
              <a
                href="https://www.paypal.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#f2eee8] hover:text-[#c8a96a] transition-colors"
                style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}
              >
                <SiPaypal className="text-2xl" />
                <span>PayPal</span>
              </a>
              <div
                className="flex items-center gap-2 text-[#f2eee8]"
                style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}
              >
                <FaMoneyBillWave className="text-2xl text-[#c8a96a]" />
                <span>Cash</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="border-t border-[#c8a96a]/30 mt-6 pt-8 text-center space-y-3">
          <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400 }}>
            © 2026 Wiggy's Wags and Wiggles. All rights reserved.
          </p>
          <div className="flex items-center justify-center gap-2 text-sm text-[#f2eee8]/80">
            <span style={{ fontFamily: 'Montserrat, sans-serif' }}>Built by</span>
            <img
              src="/full-cycle-logo.webp"
              alt="Fullcycle Studio Logo"
              className="h-5 w-auto object-contain"
            />
            <a
              href="https://www.fullcyclestudio.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold hover:text-[#c8a96a] transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Fullcycle Studio
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
